import React, { ReactNode, HTMLAttributes } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import s from "./Widget.module.scss";

interface WidgetProps extends Omit<HTMLAttributes<HTMLElement>, "title"> {
  className?: string;
  children?: ReactNode;
  title?: ReactNode;
}

/** Lightweight Widget shell used by the theme Helper panel */
function Widget({ className = "", children = null, title = null, ...attributes }: WidgetProps) {
  return (
    <section className={classNames("widget", s.widget, className)} {...attributes}>
      {title &&
        (typeof title === "string" ? (
          <h5 className={s.title}>{title}</h5>
        ) : (
          <header className={s.title}>{title}</header>
        ))}
      <div className={`${s.widgetBody} widget-body`}>{children}</div>
    </section>
  );
}

Widget.propTypes = {
  title: PropTypes.node,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default Widget;
